import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuerySample } from '@store/helpers';

export const placesApi = createApi({
  reducerPath: 'Places',
  tagTypes: ['Places'],
  baseQuery: baseQuerySample,
  endpoints: (builder) => ({
    getPlacesInfo: builder.query({
      query: () => ({
        url: '/v1/places',
      }),
    }),
    updatePlacesInfo: builder.mutation({
      query: ({ body = {} }) => ({
        url: `/v1/places/update`,
        method: 'POST',
        body,
      }),
    }),
    createOrUpdatePlacesInfo: builder.mutation({
      query: ({ body = {}, isPlacesSaved }) => ({
        url: `/v1/places/${isPlacesSaved ? 'update' : 'create'}`,
        method: isPlacesSaved ? 'PUT' : 'POST',
        body,
      }),
    }),

    getPlacesLocation: builder.query({
      query: () => ({
        url: '/v1/places/places-locations/location',
      }),
    }),
    getPlacesLocationById: builder.query({
      query: ({ id }) => ({
        url: `/v1/places/places-locations/${id}`,
      }),
    }),
    getSavedPlaces: builder.query({
      query: ({ id }) => ({
        url: `/v1/places/location/${id}`,
      }),
    }),
    createOrUpdatePlacesLocation: builder.mutation({
      query: ({ id, method, body = {} }) => ({
        url: `/v1/places/places-locations/${id ? `update/${id}` : 'create'}`,
        method,
        body,
      }),
    }),
    getPlaceServices: builder.mutation({
      query: ({
        page,
        size,
        body = {},
        params = { sortBy: 'id', sortDir: 'desc' },
      }) => ({
        url: `/v1/places/location-service?page=${page}&size=${size}`,
        method: 'POST',
        body,
        params,
      }),
    }),
    getPlacesSearchLocation: builder.mutation({
      query: ({ data }) => {
        return {
          url: '/v1/search/location/locations',
          method: 'POST',
          body: data,
        };
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useLazyGetPlacesInfoQuery,
  useUpdatePlacesInfoMutation,
  useLazyGetPlacesLocationQuery,
  useLazyGetPlacesLocationByIdQuery,
  useLazyGetSavedPlacesQuery,
  useCreateOrUpdatePlacesLocationMutation,
  useGetPlaceServicesMutation,
  useGetPlacesSearchLocationMutation,
  useCreateOrUpdatePlacesInfoMutation,
} = placesApi;
